const link = (url) => {
    if (!url) return null;
    if (url.includes("http")) return url;
    return "https://" + url;
}

const linkify = link;

const publicToString = (_public) => {
    if (_public === "on") return "Oui";
    return "Non";
}

const semicolonSeparatedToCommadSeparated = (semicolonSeparated) => {
    if (!semicolonSeparated) return "";
    return semicolonSeparated.split(";").filter(val => val).join(", ");
}

const AwardsObjectToString = (awards) => {
    if (!awards) return "";
    try {
        const awardsObject = JSON.parse(awards);
        return awardsObject.map(award => award.title + " - " + award.year).join(", ");
    } catch (e) {
        console.log(e);
        return "";
    }
}

const LiensPressesObjectToString = (liensPresses) => {
    if (!liensPresses) return "";
    try {
        const liensPressesObject = JSON.parse(liensPresses);
        return liensPressesObject.map(lien => lien.title + " - " + lien.url).join(", ");
    } catch (e) {
        console.log(e);
        return "";
    }
}


const makeUrlsAndEmailsLinks = (rawText) => {
    if (!rawText) return null;

    //urlRegex should not match urls that are already in a tag
    //Matches: https://example.com, http://example.com, www.example.com, example.com, example.fr
    //Including paths and query parameters but excluding trailing punctuation
    const urlRegex = /(?<!href=")((?:https?:\/\/|www\.)[^\s<>,;)}\]]+(?<![.,;!?)\]}])|(?<![\/\-@])[a-zA-Z0-9][a-zA-Z0-9\-]*\.(?:com|fr)(?:\/[^\s<>,;)}\]]*)?(?<![.,;!)\]}]))/g;

    //emailRegex should match any string that contains an @ and has no spaces, and should consider chevrons and line breaks as separators.
    const emailRegex = /(?![<])[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(?![>])/g;

    const linkedText = rawText.replace(urlRegex, (match) => {
        // Add https:// if the URL doesn't start with http:// or https://
        const href = match.match(/^https?:\/\//) ? match : 'https://' + match;
        return `<a target="_blank" href="${href}">${match}</a>`;
    });
    const linkedEmails = linkedText.replace(emailRegex, '<a href="mailto:$&">$&</a>');

    return <div dangerouslySetInnerHTML={{ __html: linkedEmails }} />;
}

const dateHsTodateFront = (date) => {
    if (!date) return "";

    const year = date.split("-")[0]
    const month = date.split("-")[1]
    const day = date.split("-")[2]

    return day + "-" + month + "-" + year
}
const dateFrontTodateHs = (date) => {
    if (!date) return "";

    const year = date.split("-")[2]
    const month = date.split("-")[1]
    const day = date.split("-")[0]

    return year + "-" + month + "-" + day
}

export default link;
export { dateFrontTodateHs, dateHsTodateFront, publicToString, semicolonSeparatedToCommadSeparated, AwardsObjectToString, LiensPressesObjectToString, makeUrlsAndEmailsLinks, linkify };